"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const navigation_1 = __importDefault(require("@App/navigation"));
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const HelpMenu_1 = __importDefault(require("@Components/Navigations/HelpMenu"));
const NavBarWrapper_1 = __importDefault(require("@Components/Navigations/NavBar/NavBarWrapper"));
const mobx_react_1 = require("mobx-react");
const PublicSearchNavLink_1 = __importDefault(require("@Components/Navigations/PublicSearchNavLink"));
const react_sdk_1 = require("@openfeature/react-sdk");
const NotLoggedInNavBar = () => {
    const { uiStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { value: loginMaintenanceBanner } = (0, react_sdk_1.useFlag)('login-maintenance-banner', false);
    const onLoginPage = uiStore.onLoginPage;
    return (react_1.default.createElement(NavBarWrapper_1.default, { rightBlock: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PublicSearchNavLink_1.default, null),
            react_1.default.createElement(HelpMenu_1.default, null),
            !loginMaintenanceBanner &&
                (onLoginPage ? (react_1.default.createElement(Button_1.Button, { typeLink: true, linkTo: navigation_1.default.signUp.root(), mainColor: true, type: 'primary' }, "Sign Up")) : (react_1.default.createElement(Button_1.Button, { typeLink: true, linkTo: navigation_1.default.login.root(), mainColor: true, type: 'primary' }, "Log In")))) }));
};
exports.default = (0, mobx_react_1.observer)(NotLoggedInNavBar);
